import { tabsApiConnector } from 'apiConnector/tabs/tabs';
import { ofType } from 'redux-observable';
import { of } from 'rxjs';
import { catchError, filter, map, mergeMap } from 'rxjs/operators';
import type { EpicWithThunk } from 'state/state.common';
import { secondaryPostEventsWorkspaceTabsFetchedThunk } from 'state/workspaces/secondary-market/post-event/secondaryMarketPostEvent.thunks';
import { workspaceTabsFetchFailed } from 'state/workspaces/workspace.actions';

export function fetchSecondaryPostEventsWorkspaceTabsEpic(): EpicWithThunk {
  return (action$, _state$, { httpClient }) => {
    const { getAllTabDescriptions } = tabsApiConnector(httpClient, 'secondaryMarketPostEvents');
    return action$.pipe(
      ofType('WORKSPACE_TABS_FETCH_REQUESTED'),
      filter(({ workspace }) => workspace === 'secondaryMarketPostEvents'),
      mergeMap(({ tabFetchRequestId }) =>
        getAllTabDescriptions().pipe(
          map(({ tabs, activeTabId }) => {
            return secondaryPostEventsWorkspaceTabsFetchedThunk(tabs, activeTabId, tabFetchRequestId);
          }),
          catchError((_: Error) => {
            return of(workspaceTabsFetchFailed('secondaryMarketPostEvents', tabFetchRequestId));
          }),
        ),
      ),
    );
  };
}
